import { render, staticRenderFns } from "./FeedForm.vue?vue&type=template&id=5c2259cf&"
import script from "./FeedForm.vue?vue&type=script&lang=ts&"
export * from "./FeedForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports